import React, { Component } from 'react';
import { useNavigate } from 'react-router-dom';
import { FacebookIcon, TwitterIcon, InstagramIcon, LinkedinIcon, GithubIcon } from 'lucide-react';
import { useAuth } from './auth/AuthProvider';
export const Footer = () => {
  const navigate = useNavigate();
  const {
    isAuthenticated
  } = useAuth();
  const handleNavigation = (path: string) => {
    navigate(path);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <footer className="bg-gray-50 dark:bg-[#0B2C2A] pt-16 pb-8" data-id="element-1028">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1029">
        {/* Main footer row — 4 columns */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mb-12" data-id="element-1030">
          {/* Company links */}
          <div data-id="element-1031">
            <h3 className="font-semibold text-gray-900 dark:text-[#F8FAF9] mb-4" data-id="element-1032">
              Company
            </h3>
            <ul className="space-y-3" data-id="element-1033">
              <li data-id="element-1034">
                <button onClick={() => handleNavigation(isAuthenticated ? '/sell-product' : '/sell-with-us')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1035">
                  Start Selling
                </button>
              </li>
              <li data-id="element-1036">
                <button onClick={() => handleNavigation('/about')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1037">
                  About Us
                </button>
              </li>

              <li data-id="element-1038">
                <button onClick={() => handleNavigation('/contact')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1039">
                  Contact
                </button>
              </li>
              <li data-id="element-1040">
                <button onClick={() => handleNavigation('/faq')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1041">
                  FAQs
                </button>
              </li>
              <li data-id="element-1042">
                <button onClick={() => handleNavigation('/privacy-policy')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1043">
                  Privacy Policy
                </button>
              </li>
              <li data-id="element-1044">
                <button onClick={() => handleNavigation('/terms')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1045">
                  Terms of Service
                </button>
              </li>
            </ul>
          </div>
        </div>
        {/* Social icons — centered (replace # with your social media URLs) */}
        <div className="flex justify-center space-x-5 mb-8" data-id="element-1046">
          <span className="text-gray-400 dark:text-[#7A8F8A] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors cursor-pointer" data-id="element-1047">
            <FacebookIcon className="h-5 w-5" data-id="element-1048" />
          </span>
          <span className="text-gray-400 dark:text-[#7A8F8A] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors cursor-pointer" data-id="element-1049">
            <TwitterIcon className="h-5 w-5" data-id="element-1050" />
          </span>
          <span className="text-gray-400 dark:text-[#7A8F8A] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors cursor-pointer" data-id="element-1051">
            <InstagramIcon className="h-5 w-5" data-id="element-1052" />
          </span>
          <span className="text-gray-400 dark:text-[#7A8F8A] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors cursor-pointer" data-id="element-1053">
            <LinkedinIcon className="h-5 w-5" data-id="element-1054" />
          </span>
          <span className="text-gray-400 dark:text-[#7A8F8A] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors cursor-pointer" data-id="element-1055">
            <GithubIcon className="h-5 w-5" data-id="element-1056" />
          </span>
        </div>
        {/* Bottom bar */}
        <div className="pt-8 border-t border-gray-200 dark:border-[#1A3330] flex flex-col md:flex-row justify-between items-center" data-id="element-1057">
          <p className="text-gray-500 dark:text-[#7A8F8A] text-sm mb-4 md:mb-0" data-id="element-1058">
            © {new Date().getFullYear()} DGStack. All rights reserved.
          </p>
          <div className="flex items-center space-x-6" data-id="element-1059">
            <button onClick={() => handleNavigation('/privacy-policy')} className="text-gray-500 dark:text-[#7A8F8A] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] text-sm transition-colors" data-id="element-1060">
              Privacy Policy
            </button>
            <button onClick={() => handleNavigation('/terms')} className="text-gray-500 dark:text-[#7A8F8A] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] text-sm transition-colors" data-id="element-1061">
              Terms of Service
            </button>
            <button onClick={() => handleNavigation('/privacy-policy#cookies')} className="text-gray-500 dark:text-[#7A8F8A] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] text-sm transition-colors" data-id="element-1062">
              Cookie Policy
            </button>
          </div>
        </div>
      </div>
    </footer>;
};